<template>
    <div>
        <v-card
            style="background-color: transparent"
            elevation="0"
            v-if="!activeUploadDocuments"
            class="oss-card"
        >
            <v-card-title
                :class="
                    !$vuetify.display.mobile
                        ? 'title font-weight-regular justify-space-between d-flex'
                        : 'title font-weight-regular pa-1'
                "
            >
                <span>{{ wizardStepTitle }}</span>
                <v-avatar
                    color="primary lighten-2"
                    class="subheading white--text"
                    size="24"
                    v-text="wizardStep"
                    v-if="!$vuetify.display.mobile"
                />
            </v-card-title>

            <v-window
                v-model="wizardStep"
                touchless
                :style="!$vuetify.display.mobile ? 'min-height: 27vh;' : ''"
            >
                <v-window-item :value="1">
                    <v-card-text class="pa-0">
                        <div>
                            <v-text-field-filled
                                v-model="expenseReport.name"
                                placeholder="Nom de la note de frais"
                                single-line
                                :autofocus="$vuetify.display.smAndUp"
                                outlined
                                data-cy="ExpenseReportWizard-name"
                                density="compact"
                            />
                        </div>
                        <div class="mt-3">
                            <FreeTag
                                :company="companyId"
                                :splitUserPartitions="true"
                                :companyTags="allCompanyTags"
                                @onTagsChanged="onTagsChanged"
                            />
                        </div>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="2">
                    <v-card-text class="pa-0">
                        <SelectUser
                            ref="selectUser"
                            v-model="expenseReportUser"
                            :companyId="companyId"
                            :type="'NATURAL_PERSON'"
                            :actions="actions"
                            :autoSelect="true"
                            height="50vh"
                            v-if="wizardStep === 2"
                            data-cy="ExpenseReportWizard-selectUser"
                        />
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="3">
                    <v-card-text class="pa-0">
                        <!-- <oss-date-picker
                            v-bind:date="date"
                            @change-date="onDateChanged"
                        ></oss-date-picker> -->
                        <v-date-picker-wrapper
                            locale="fr-FR"
                            v-model="dateValue"
                            width="100%"
                            :landscape="!$vuetify.display.mobile"
                            class="elevation-0"
                            color="gradient"
                            scrollable
                            data-cy="ExpenseReportWizard-date"
                        />
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="4">
                    <v-card-text class="pa-0">
                        {{
                            $t("shared.amountOfFiles", expenseReport.documents.length || 0, {
                                count: expenseReport.documents.length || 0,
                            })
                        }}
                        <v-list lines="two">
                            <v-list-item
                                v-for="(document, i) in expenseReport.documents"
                                :key="i"
                                :class="
                                    !$vuetify.display.mobile
                                        ? 'mb-2 py-2 oss-list-item'
                                        : 'mb-2 pa-2 oss-list-item'
                                "
                            >
                                <template #prepend>
                                    <v-menu
                                        open-on-hover
                                        offset-x
                                        v-if="document.signedUrl"
                                        location="end"
                                    >
                                        <template v-slot:activator="{ props }">
                                            <v-img
                                                :src="document.signedUrl"
                                                height="50px"
                                                v-bind="props"
                                            />
                                        </template>
                                        <v-card>
                                            <v-img :src="document.signedUrl" width="800px" />
                                        </v-card>
                                    </v-menu>
                                    <v-icon v-else-if="document.travelExpense"
                                        >$directions_car</v-icon
                                    >
                                </template>
                                <div class="w-100 py-0">
                                    <v-list-item-title v-if="!document.travelExpense">
                                        <v-select-filled
                                            rounded
                                            v-model="document.accountableAccount.name"
                                            :items="categories"
                                            placeholder="Catégorie"
                                            label="Catégorie"
                                            single-line
                                            outlined
                                            class="pt-0"
                                            @update:model-value="categoryChange(document)"
                                            density="compact"
                                            item-title="text"
                                        />
                                    </v-list-item-title>
                                    <v-list-item-title v-else>
                                        {{ getCategoryText(document.accountableAccount) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        <v-row no-gutters>
                                            <v-col cols="6" class="text-left">
                                                {{
                                                    getDateFormated(
                                                        document.date || expenseReport.date,
                                                    )
                                                }}
                                            </v-col>
                                            <v-col cols="6" class="text-right">
                                                {{
                                                    document.grossAmount
                                                        ? newCommonFormatCurrency(
                                                              document.grossAmount,
                                                              undefined,
                                                          )
                                                        : "-"
                                                }}
                                            </v-col>
                                        </v-row>
                                    </v-list-item-subtitle>
                                </div>

                                <template v-slot:append class="my-0">
                                    <v-btn-icon
                                        icon="$delete_outline"
                                        @click="deleteCategory(document)"
                                    />
                                </template>
                            </v-list-item>
                        </v-list>
                        <v-row no-gutters>
                            <v-col cols="12" class="text-center">
                                <v-btn
                                    rounded
                                    @click="
                                        openCameraOnly
                                            ? openCamera()
                                            : (activeUploadDocuments = true);
                                        activeTravelExpense = false;
                                    "
                                    class="btn mr-2"
                                    data-cy="expenseReport-import-document"
                                    size="small"
                                    >Nouvelles factures</v-btn
                                >
                                <v-btn
                                    class="btn ml-2"
                                    rounded
                                    @click="
                                        currentTravelExpenseDocument = null;
                                        wizardStep = 5;
                                    "
                                    data-cy="expenseReport-new-travelExpense"
                                    size="small"
                                    >Frais kilométriques</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-window-item>
                <v-window-item class="pb-2" :value="5">
                    <ExpenseReportAddress
                        :travelExpense="currentTravelExpense"
                        :isOwner="true"
                        :year="year"
                        @origin="setOrigin($event)"
                        @destination="setDestination($event)"
                    />
                </v-window-item>
            </v-window>
            <v-card-actions v-if="!actions">
                <v-spacer />
                <v-btn
                    rounded
                    style="color: #fff"
                    class="btn mr-0"
                    @click.prevent="nextStep()"
                    v-if="wizardStep >= 1 && wizardStep <= 3"
                    :disabled="!expenseReport.name"
                    data-cy="expenseReport-next"
                    size="small"
                >
                    Suivant
                </v-btn>
                <v-btn
                    rounded
                    style="color: #fff"
                    class="btn mr-0"
                    :disabled="
                        !expenseReport.name ||
                        !expenseReport.documents ||
                        !expenseReport.documents.length
                    "
                    v-if="wizardStep === 4"
                    @click.prevent="save(true)"
                    data-cy="expenseReport-create"
                    size="small"
                >
                    Créer
                </v-btn>
                <v-btn-primary
                    style="float: right"
                    rounded
                    :disabled="!commonEnableModification || !currentTravelExpenseAmount"
                    v-if="wizardStep === 5 && !currentTravelExpenseDocument"
                    @click="
                        newTravelExpense();
                        wizardStep = 4;
                    "
                    data-cy="expenseReport-add-travelExpense"
                    size="small"
                    >Ajouter
                </v-btn-primary>
            </v-card-actions>
        </v-card>
        <UploadDocuments
            v-else
            ref="uploadDocument"
            :disableAutoOpenFileDialog="true"
            :companyId="companyId"
            :documentType="'EXPENSE_REPORT_DOCUMENT'"
            :actions="actions"
            :ownerId="expenseReportUser.id"
            @back="onUDBack()"
            @new-document="onNewDocument($event)"
            @files-uploaded="filesUploaded()"
        />
    </div>
</template>

<script lang="ts">
import { ExpenseReportBase } from "./ExpenseReportBase";

import UploadDocumentsComp, { UploadDocuments } from "../document/UploadDocuments.vue";
import SelectUserComp, { SelectUser } from "../user/SelectUser.vue";
import ExpenseReportAddress from "./ExpenseReportAddress.vue";
import FreeTag from "../tag/FreeTag.vue";
import { Component, Ref, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch, Emit } from "vue-facing-decorator";
import moment from "moment-timezone";
import gql from "graphql-tag";

// import moment from "moment-timezone";

@Component({
    components: {
        UploadDocuments: UploadDocumentsComp,
        SelectUser: SelectUserComp,
        ExpenseReportAddress,
        FreeTag,
    },
})
export class ExpenseReportWizard extends ExpenseReportBase {
    @Prop({ default: true }) readonly showFirstPrevious: boolean;
    @Prop({ default: null }) actions: any;
    @Prop({ default: false }) readonly openCameraOnly: boolean;

    get dateValue() {
        if (this.expenseReport?.date) {
            return moment(this.expenseReport.date).format("YYYY-MM-DD");
        }
        return null;
    }

    set dateValue(value) {
        this.expenseReport.date = moment(value).format("YYYY-MM-DD");
    }

    get activateTagguing() {
        return true;
    }

    wizardStep_: number = 1;

    get wizardStep() {
        return this.wizardStep_;
    }

    set wizardStep(data) {
        this.wizardStep_ = data;
        if (this.actions && this.actions.action) {
            if (this.wizardStep === 1 || this.wizardStep === 3) {
                this.actions.action.display = true;
                this.actions.action.disabled = () => {
                    return !this.expenseReport.name;
                };
                this.actions.action.title = "Suivant";
                this.actions.action.function = this.nextStep;
            } else if (this.wizardStep === 4) {
                this.actions.action.display = true;
                this.actions.action.disabled = () => {
                    return (
                        !this.expenseReport.name ||
                        !this.expenseReport.documents ||
                        !this.expenseReport.documents.length
                    );
                };
                this.actions.action.title = "Créer";
                this.actions.action.function = () => {
                    this.save(true);
                };
            } else if (this.wizardStep === 5 && !this.currentTravelExpenseDocument) {
                this.actions.action.display = true;
                this.actions.action.disabled = () => {
                    return !this.commonEnableModification || !this.currentTravelExpenseAmount;
                };
                this.actions.action.title = "Ajouter";
                this.actions.action.function = () => {
                    this.newTravelExpense();
                    this.wizardStep = 4;
                };
            } else if (this.wizardStep === 2) {
                // SelectUser widget step
                this.actions.action.display = true;
                // Disable button if no user is selected
                this.actions.action.disabled = () => {
                    return !this.expenseReportUser?.id;
                };
            } else {
                this.actions.action.display = false;
            }
        }
    }

    /**
     *  Delete expense report document record from the database and remove it from the list
     * @param document
     */
    async deleteCategory(document): Promise<void> {
        debugger;
        if (document.id && this.expenseReport.id) {
            debugger;
            const deleted = await this.deleteExpenseReportDocumentFromDB(
                document.id,
                this.expenseReport.id,
            );
            if (deleted) {
                const index = this.expenseReport.documents.findIndex((x) => x.id === document.id);
                this.expenseReport.documents.splice(index, 1);
            }
        }
    }

    /**
     * Delete document record from the database
     * @param documentId
     * @param expenseReportId
     * @returns Promise<boolean>
     */
    async deleteExpenseReportDocumentFromDB(
        documentId: string,
        expenseReportId: string,
    ): Promise<boolean> {
        debugger;
        if (expenseReportId && documentId) {
            const response = await this.$apollo.mutate({
                mutation: gql`
                    mutation deleteExpenseReportDocument($expenseReportId: ID!, $documentId: ID!) {
                        deleteExpenseReportDocument(
                            where: { expenseReportId: $expenseReportId, documentId: $documentId }
                        ) {
                            success
                        }
                    }
                `,
                variables: {
                    expenseReportId: expenseReportId,
                    documentId: documentId,
                },
            });
            console.log(response);
            if (response.data.deleteExpenseReportDocument?.success) {
                return true;
            }
        }
        return false;
    }

    get expenseReportUser() {
        return this.expenseReport.user;
    }

    set expenseReportUser(data) {
        this.expenseReport.user = data;
        this.nextStep();
        if (this.$vuetify.display.mobile) {
            this.nextStep();
        }
    }

    beforeMount() {
        this._mounted();
        if (this.actions && this.actions.action) {
            this.actions.action.display = true;
            this.actions.action.disabled = () => {
                return !this.expenseReport.name;
            };
            this.actions.action.title = "Suivant";
            this.actions.action.function = this.nextStep;
        }
        if (this.$vuetify.display.mobile) {
            debugger;
            if (this.expenseReport?.user?.id) {
                this.wizardStep = 5;
            } else {
                this.wizardStep = 2;
            }
            this.expenseReport.name =
                "Note de frais de " +
                this.expenseReport.user.firstname +
                " " +
                this.expenseReport.user.lastname +
                " du " +
                this.expenseReport.date.format("DD MMMM YYYY");
        }
        this.addListener("document");
    }

    onMessage(data: any): void {
        const { id } = data;
        const document = this.expenseReport.documents.find((d) => d.id === id);
        if (document) {
            document.status = data.payload.status;
        }
    }

    @Ref("uploadDocument") uploadDocument!: UploadDocuments;
    async uploadPhotoCamera(e) {
        debugger;
        if (this.uploadDocument) {
            const file = this.cameraPhotoFile;

            this.uploadDocument.addToFiles(file);
        }
    }

    get wizardStepTitle() {
        switch (this.wizardStep) {
            case 1:
                return "Choisissez un nom pour la note de frais";
            case 2:
                return "Choisissez le collaborateur";
            case 3:
                return "Choisissez la date";
            case 4:
                return "Ajouter des factures ou des frais kilométriques";
            case 5:
                return "Ajouter des frais kilométriques";
        }
        return "Title" + this.wizardStep;
    }

    // disabledNextStep() {
    //     if (this.wizardStep >= 4) return true;
    //     return false;
    // }

    nextStep() {
        this.wizardStep++;
    }

    @Emit("back")
    onBack() {
        return;
    }

    @Ref("selectUser") selectUser!: SelectUser;
    previousStep() {
        if (this.wizardStep <= 0) return;
        if (this.wizardStep === 1) {
            this.onBack();
            return;
        }
        if (this.wizardStep === 2) {
            debugger;
            if (this.$refs?.selectUser?.step !== "selectUser") {
                this.selectUser.step_ = "selectUser";
                this.wizardStep = this.wizardStep_;
                // return;
            }
            this.wizardStep = 1;
            return;
        }
        if (this.wizardStep === 4) {
            if (this.activeUploadDocuments) {
                this.activeUploadDocuments = false;
            }
            return;
        }
        this.wizardStep--;
    }

    onUDBack() {
        this.activeUploadDocuments = false;
    }

    // onUserSelected(data) {
    //     this.expenseReport.user = data;
    // }

    documentToSave = [];
    async onNewDocument(document) {
        this.documentToSave.push(document);
        // debugger
        // await this.newDocument(document)
        if (this.openCameraOnly) {
            await this.save(true);
        }
    }

    async filesUploaded() {
        debugger;
        for (const document of this.documentToSave) {
            await this.newDocument(document);
        }
        this.onFilesUploaded();
        await this.save();
    }

    @Watch("activeUploadDocuments")
    setActions() {
        if (!this.activeUploadDocuments) {
            if (this.actions && this.actions.action) {
                if (this.wizardStep === 1 || this.wizardStep === 3) {
                    this.actions.action.display = true;
                    this.actions.action.disabled = () => {
                        return !this.expenseReport.name;
                    };
                    this.actions.action.title = "Suivant";
                    this.actions.action.function = this.nextStep;
                } else if (this.wizardStep === 4) {
                    this.actions.action.display = true;
                    this.actions.action.disabled = false;
                    this.actions.action.title = "Créer";
                    this.actions.action.function = () => {
                        this.save(true);
                    };
                } else if (this.wizardStep === 5 && !this.currentTravelExpenseDocument) {
                    this.actions.action.display = true;
                    this.actions.action.disabled = () => {
                        return !this.commonEnableModification || !this.currentTravelExpenseAmount;
                    };
                    this.actions.action.title = "Ajouter";
                    this.actions.action.function = () => {
                        this.newTravelExpense();
                        this.wizardStep = 4;
                    };
                } else {
                    this.actions.action.display = false;
                }
            }
        }
    }
    @Ref("cameraPhotoFile") cameraPhotoFile!: HTMLInputElement;
    openCamera() {
        if (this.$vuetify.display.mobile && this.openCameraOnly && this.cameraPhotoFile) {
            this.cameraPhotoFile.click();
        }
    }
}

export default toNative(ExpenseReportWizard);
</script>
<style lang="scss" scoped>
.v-list-item {
    min-height: auto !important;
}
::-webkit-file-upload-button {
    border-width: 0px;
    border: none;
    background: transparent;
    color: transparent;
}
</style>
